import { gql } from '@apollo/client';
import type { EEmployeeTalkStatus } from '@sharedInterfaces/IEmployeeTalk';
import EmployeeTalk, { EmployeeTalkGQL } from '@src/Objects/EmployeeTalk';
import { updateEmployeeTalk as updateEmployeeTalkAction } from '@store/reducer/employeeTalksReducer';
import store from '@store/store';

import GraphQL from '../graphQL';

const m = gql`
  mutation UpdateEmployeeTalk(
    $id: Int!
    $title: String
    $employeeId: Int
    $meetingPartnerId: Int
    $templateId: Int
    $scheduledDate: String
    $actualDate: String
    $durationMinutes: Int
    $loc: String
    $status2: String
    $followUpDate: String
    $employeeConfirmed: Boolean
    $partnerConfirmed: Boolean
    $talkState: JSON
  ) {
    updateEmployeeTalk(
      id: $id
      title: $title
      employeeId: $employeeId
      meetingPartnerId: $meetingPartnerId
      templateId: $templateId
      scheduledDate: $scheduledDate
      actualDate: $actualDate
      durationMinutes: $durationMinutes
      loc: $loc
      status2: $status2
      followUpDate: $followUpDate
      employeeConfirmed: $employeeConfirmed
      partnerConfirmed: $partnerConfirmed
      talkState: $talkState
    ) ${EmployeeTalkGQL}
  }
`;

export default async function updateEmployeeTalk(
    id: number,
    updates: {
        title?: string;
        employeeId?: number;
        meetingPartnerId?: number;
        templateId?: number;
        scheduledDate?: Date;
        actualDate?: Date;
        durationMinutes?: number;
        loc?: string;
        status2?: EEmployeeTalkStatus;
        followUpDate?: Date;
        employeeConfirmed?: boolean;
        partnerConfirmed?: boolean;
        talkState?: Record<string, any>;
    },
): Promise<EmployeeTalk> {
    const variables = {
        id,
        ...updates,
        scheduledDate: updates.scheduledDate?.toISOString(),
        actualDate: updates.actualDate?.toISOString(),
        followUpDate: updates.followUpDate?.toISOString(),
    };

    return GraphQL.mutate<any>(m, variables).then((data) => {
        const employeeTalk = new EmployeeTalk(data);
        store.dispatch(updateEmployeeTalkAction(employeeTalk));
        return employeeTalk;
    });
}
